import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { LinearProgress } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import { ProgressCaption } from "./Typography";
export const useStyles = makeStyles(({ palette: { primary }, additionalColors: { blue900 } }) => createStyles({
    bars: {
        display: "grid",
        gridTemplateColumns: "auto",
        gridTemplateRows: "auto",
    },
    main: {
        gridRowStart: 1,
        gridColumnStart: 1,
    },
    overflow: {
        gridRowStart: 1,
        gridColumnStart: 1,
        zIndex: 1,
        backgroundColor: primary.main,
    },
    overflowBar: {
        backgroundColor: blue900,
    },
}));
export const LabeledProgressBar = ({ current, target, unit, hideNumbers }) => {
    const classes = useStyles();
    const value = (100 * current) / target;
    return (_jsxs(_Fragment, { children: [_jsx(ProgressCaption, { current: current, target: target, unit: unit, hideNumbers: hideNumbers }), _jsxs("div", { className: classes.bars, children: [_jsx(LinearProgress, { className: classes.main, variant: "determinate", value: Math.min(100, value) }), value > 100 && (_jsx(LinearProgress, { className: classes.overflow, classes: { bar: classes.overflowBar }, variant: "determinate", value: Math.min(100, value - 100) }))] })] }));
};
//# sourceMappingURL=LabeledProgressBar.js.map